import {
  FETCH_LIST_CITY_SUCCESS,
  FETCH_LIST_DISTRICT_SUCCESS,
  FETCH_LIST_WARD_SUCCESS,
} from "redux/ActionTypes/AddressTypes";

const initialState = {
  cities: [],
  districts: [],
  wards: [],
};

const AddressReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIST_CITY_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, cities: newList };
    }
    case FETCH_LIST_DISTRICT_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, districts: newList };
    }
    case FETCH_LIST_WARD_SUCCESS: {
      const newList = [...action.payload];
      return { ...state, wards: newList };
    }
    default:
      return { ...state };
  }
};

export default AddressReducers;
